<template>
  <div class="cn_page_tag" style="display: none">{{ name }}</div>
</template>

<script setup lang="ts">
defineProps({
  name: {
    type: String,
  },
})
</script>
